import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "isCloseable", "title", "type", "onClose", "setLocalStorage", "fullWidthTitle"];
import { forwardRef, memo, useCallback, useEffect, useRef, useState } from 'react';
import { get, set } from '../../../utils/tempStorage';
import { AlertWrapper, AlertTitle } from './AbstractBannerComponents';
import { Flex } from 'foundations-components/components/Flex';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AbstractBanner = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
      children,
      isCloseable,
      title,
      type = 'info',
      onClose,
      setLocalStorage = true,
      fullWidthTitle = false
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const [isHidden, setIsHidden] = useState(isCloseable);
  const storageKey = isCloseable ? props.storageKey : undefined;
  const portalId = isCloseable ? props.portalId : undefined;
  const localRef = useRef(undefined);
  const portalStorageKey = `${storageKey}${portalId ? `-${portalId}` : ''}`;
  const setRef = useCallback(el => {
    localRef.current = el;
    if (typeof forwardedRef === 'function') forwardedRef(el);else if (forwardedRef !== null) forwardedRef.current = el;
  }, [forwardedRef]);
  useEffect(() => {
    if (isCloseable) {
      try {
        const isHiddenStorage = get(portalStorageKey) === 'true';
        setIsHidden(isHiddenStorage);
      } catch (_unused) {
        setIsHidden(false);
      }
    }
  }, [portalStorageKey, isCloseable]);
  const handleClose = (key, value) => {
    if (onClose) {
      onClose();
    }
    if (setLocalStorage) {
      set(key, value.toString());
    }
    setIsHidden(true);
  };
  return !isHidden ? /*#__PURE__*/_jsxs(AlertWrapper, Object.assign({
    role: "banner",
    type: type,
    ref: setRef
  }, rest, {
    children: [/*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexWrap: "wrap",
      inlineSize: "100%",
      paddingInlineEnd: isCloseable ? '600 !important' : undefined,
      children: [title && /*#__PURE__*/_jsx(AlertTitle, {
        "data-test-id": "alertTitle",
        fullWidthTitle: fullWidthTitle,
        children: title
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flexWrap: "wrap",
        paddingInlineEnd: isCloseable ? '600 !important' : undefined,
        children: children
      })]
    }), isCloseable && /*#__PURE__*/_jsx(CloseButton, {
      color: "icon-core-default",
      "data-test-id": "banner-close-button",
      onClick: () => handleClose(portalStorageKey, true),
      size: "md"
    })]
  })) : null;
});
export default /*#__PURE__*/memo(AbstractBanner);